import { render } from "./HeaderTwo.vue?vue&type=template&id=5542f62e&scoped=true"
import script from "./HeaderTwo.vue?vue&type=script&lang=js"
export * from "./HeaderTwo.vue?vue&type=script&lang=js"

import "./HeaderTwo.vue?vue&type=style&index=0&id=5542f62e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5542f62e"]])

export default __exports__